module.exports = __webpack_public_path__ + "static/img/011.b699e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/011.png
// module id = +8fO
// module chunks = 1